import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isAuthor: false,
    token: "test",
    currency: 0,
    permissions: [],
    userPermission: [],
};

export const statusSlice = createSlice({
    name: "status",
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.isAuthor = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setCurrency: (state, action) => {
            state.currency = action.payload;
        },
        setPermissions: (state, action) => {
            state.permissions = action.payload;
        },
        setUserPermission: (state, action) => {
            state.userPermission = action.payload;
        },
    },
});

export const { setStatus, setToken, setCurrency, setPermissions, setUserPermission } = statusSlice.actions;

export default statusSlice.reducer;
